export default __webpack_public_path__ + "static/media/LargeDisplay.455eca0f.png";